import { IconBack } from '../../../../assets/index';
import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import ForgotPassword1 from './components/ForgotPassword1';
import ForgotPassword2 from './components/ForgotPassword2';
import ForgotPassword3 from './components/ForgotPassword3';
import './MobileForgot.scss';
import { useHistory } from 'react-router-dom';
import { isAuthenticate } from '../../../../utils/helpers/helpers';
import { routes } from '../../../../utils/constants/constant';

const MobileForgot = (props) => {
  const [step, setStep] = useState(1);
  const history = useHistory();
  const [dataForm, setDataForm] = useState({});
  useEffect(() => {
    setStep(1);
  }, []);

  const handleChangeStep = (valueStep = 1) => {
    setStep(valueStep);
    if (valueStep === 4) {
      // handleVisible('LOGIN_MODAL');
    }
  };

  const handleChangeDataForm = (data = {}) => {
    setDataForm(data);
  };

  const handleBack = () => {
    step !== 1 ? setStep(step - 1) : history.goBack();
  };
  if (isAuthenticate()) {
    history.push(routes.DASHBOARD);
    return null;
  }
  return (
    <div className='mobile-forgot'>
      <div className='btn-back' onClick={handleBack}>
        <div className='icon-back'>
          <IconBack />
        </div>
        Quên mật khẩu
      </div>
      {step === 1 ? (
        <ForgotPassword1
          handleChangeStep={handleChangeStep}
          // handleVisible={handleVisible}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      ) : step === 2 ? (
        <ForgotPassword2
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      ) : (
        <ForgotPassword3
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      )}
    </div>
  );
};

export default MobileForgot;
